export const ACCOUNTING_MODELS_FILTERS = {
    filters: [
        {
            name: 'InAgencyFrom',
            label: 'In Agency Since',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'period',
            type: 'period',
        },
        {
            name: 'DepartmentID',
            label: 'Department',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            emptyValue: true,
            mode: 'single',
            type: 'departments-selector-accounting',
        },
        {
            name: 'InTown',
            label: 'In Town',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'intown-selector',
        },
        {
            name: 'Storage',
            label: 'In Storage',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'filter-yes-no-all',
        },
        {
            name: 'Published',
            label: 'Published playlists',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'published-filter',
        },
        {
            name: 'AgencyID',
            label: 'Working with agency',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'agency-selector',
        },
        {
            name: 'AgencyType',
            label: 'as:',
            description: 'agency relationship type',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'agency-type-selector',
        },
        {
            name: 'AgencyNotIn',
            label: 'exclude condition',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'AgencyCities',
            label: 'cities',
            area: 'agency',
            areaIndex: 2,
            defaultval: [],
            commontype: 'array',
            type: 'cities-selector',
        },
        {
            name: 'AgencyCountry',
            label: 'country',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'country-selector',
        },
        {
            name: 'AgencyIncludeDropped',
            label: 'Include Dropped',
            area: 'agency',
            areaIndex: 2,
            defaultval: false,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'Represented',
            label: 'Represented',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'AgeRange',
            label: 'Age',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [null, null],
            commontype: null,
            type: 'age-range',
        },
        // {
        //     name: 'AgeSince',
        //     label: 'Age - From',
        //     area: 'demographic',
        //     areaIndex: 3,
        //     defaultval: null,
        //     commontype: null,
        //     type: 'number',
        // },
        // {
        //     name: 'AgeUntil',
        //     label: 'Age - To',
        //     description: 'inclusive',
        //     area: 'demographic',
        //     areaIndex: 3,
        //     defaultval: null,
        //     commontype: null,
        //     type: 'number',
        // },
        {
            name: 'Nationality',
            label: 'Nationality',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'country-selector',
        },
        {
            name: 'CommissionRange',
            label: 'Agency Commission',
            area: 'billing',
            areaIndex: 4,
            defaultval: [0, 100],
            commontype: null,
            type: 'percentage-range',
        },
        {
            name: 'InvoiceType',
            label: 'Invoice Type',
            area: 'billing',
            areaIndex: 4,
            defaultval: null,
            commontype: null,
            type: 'invoice-type-selector',
        },
        {
            name: 'HasVat',
            label: 'Has VAT Number',
            area: 'billing',
            areaIndex: 4,
            defaultval: null,
            commontype: null,
            type: 'filter-yes-no-all',
        },
        {
            name: 'Statement',
            label: 'Statement',
            area: 'billing',
            areaIndex: 4,
            defaultval: [null, null, null, null],
            commontype: null,
            type: 'statement-filter',
        },
        {
            name: 'Document',
            label: 'Documents Status',
            area: 'documents',
            areaIndex: 5,
            defaultval: [null, null],
            commontype: null,
            type: 'legal-status-filter',
        },
        {
            name: 'YearlyDocument',
            label: 'Yearly Documents Status',
            area: 'documents',
            areaIndex: 5,
            defaultval: [null, null],
            commontype: null,
            type: 'legal-yearly-status-filter',
        },
    ],
};
